<template>
  <div class="error_message_list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong class="text-uppercase">{{$t('error_message.error_message') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createErrorMessage">
                  <i class="fa fa-plus"></i>&nbsp; {{$t('error_message.new')}}
                </button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <!-- Start of Filter session -->
              <b-row>
                <b-row class="mb-3">
                  <b-col xl="12">
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('error_message.active')">
                        <b-form-select v-model="filter.active"
                                       v-bind:value="filter.active"
                                       :options="statuses[$session.get('lang')]"
                                       v-bind:placeholder="$t('error_message.active')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('error_message.service')">
                        <b-form-select v-model="filter.service" v-bind:value="filter.service"
                                       :options="services"
                                       v-bind:placeholder="$t('error_message.service')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                  </b-col>
                </b-row>
                <b-col xl="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options"
                                     v-bind:selected="filter.selected"
                                     position="prepend"
                                     v-bind:all="false"
                                     v-model="filter.field"
                                     prefix="error_message">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key"  v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search"></i>
                          {{$t('common.search')}}
                        </b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('error_message.active')}}</th>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id"
                        @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted"
                         v-if="dataTable.sort.type === 'asc' && dataTable.sort.field === item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                         v-if="dataTable.sort.type === 'desc' && dataTable.sort.field === item.name"></i>
                      <span v-if="item.label != null">{{$t('error_message.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('error_message.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length === 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 5">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success"
                                v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                v-model="item.active" :value="1" :uncheckedValue="0"
                                @change="updateStatusItem(item)"/>
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                                            <span v-if="field.render != null"
                                                  v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                                                 {{item[field.name]}}
                                            </span>
                    </td>
                    <td scope="row" width="100">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                                v-model="dataTable.currentPage"/>
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total:
                  dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]"
                                 class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .table thead th:nth-child(1) {
    width: 100px;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }

  .custom-control-label::before {
    border-radius: 3px !important;
  }
</style>
<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import axios from 'axios/index'
  import cSwitch from '../../../components/Switch'

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null

  export default {
    name: 'ErrorMessageList',
    components: {
      SelectDropdown,
      cSwitch,
    },
    data: function () {
      return {
        filter: {
          options: [],
          service: '',
          error_code: '',
          error_message: '',
          active: 1,
          field: null,
          key: null,
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'service',
              label: 'service',
              filter: false,
              sort: true,
              render: (data) => {
                return data
              }
            },
            {
              name: 'error_code',
              label: 'error_code',
              filter: true,
              sort: true,
              render: (data) => {
                return data
              }
            },
            {
              name: 'error_message',
              label: 'error_message',
              filter: true,
              sort: true,
              render: (data) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
          ],
          sort: {
            field: 'id',
            type: 'asc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        statuses: [],
        services: [],
      }
    },
    methods: {
    /**
       * update sort field and sort type then refresh data
       * @param field
       */
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (!this.dataTable.fields.hasOwnProperty(i)) continue
          if (this.dataTable.fields[i].name === field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort === false)) {
            return
          }
        }
        if (this.dataTable.sort.field !== field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type === 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * refresh data for data table
       */
      refreshData () {
        //get params
        let _data = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type
        }

        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          _data[this.filter.field] = this.filter.key.trim()
        }

        if (String(this.filter.active) !== '') {
          _data['active'] = this.filter.active
        }

        if (String(this.filter.service) !== '') {
          _data['service'] = this.filter.service
        }

        //process to send via get method
        let params = ''
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        //remove tail
        params = params.slice(0, -1)

        vm.axios.tenant.getListErrorMessage(params, function (response) {
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.pagination.total
          this.$forceUpdate()
        })
      },
      /**
       * move to detail page by uuid
       * @param uuid
       */
      editItem (uuid) {
        this.$router.push({name: 'error_message_edit', params: {uuid: uuid}})
      },
      createErrorMessage: function () {
        this.$router.push({name: 'error_message_create', params: {uuid: 'create'}})
      },
      getStatusData () {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
        }
      },
      /**
       * update active by uuid
       * @param item and active
       */
      updateStatusItem (item) {
        let params = {
          uuid: item.uuid,
          service: item.service,
          error_code: item.error_code,
          active: item.active
        }
        this.axios.menu.updateErrorMessage(params, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.refreshData()
        })
      }
    },
    created: function () {
      this.debouncedInput = _.debounce(this.refreshData, 240)
      vm = this

      for (let i in vm.dataTable.fields) {
        if (!vm.dataTable.fields.hasOwnProperty(i)) continue
        let field = vm.dataTable.fields[i].name
        if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter === true) {
          vm.filter.options.push(vm.dataTable.fields[i])
        }
        if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort === true && vm.dataTable.sort.field == null) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }
      vm.$Progress.start()
      let filter = this.$session.get('filter', null)
      if (filter != null && this.$route.query && this.$route.query.rollback) {
        for (let i in filter.filter) {
          if (!filter.filter.hasOwnProperty(i)) continue
          this.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          if (!filter.dataTable.hasOwnProperty(i)) continue
          this.dataTable[i] = filter.dataTable[i]
        }
      }
      vm.getStatusData ()

      if(vm.services.length > 0) {
        vm.refreshData()
      } else {
        vm.axios.tenant.getListErrorService('', function (response) {
          vm.services.push({text: vm.$t('common.all'), value: ''})
          for(let i in response.data.data.items){
            vm.services.push({text: response.data.data.items[i].service_name, value: response.data.data.items[i].service_name})
          }
          vm.refreshData()
        })
      }
    },
    beforeDestroy: function () {
      this.$session.set('filter', {
        filter: this.filter,
        dataTable: {
          sort: {
            field: this.dataTable.sort.field,
            type: this.dataTable.sort.type
          },
          currentPage: this.dataTable.currentPage,
          perPage: this.dataTable.perPage
        }
      })
    },
    watch: {
      'filter.key': function () {
        this.debouncedInput()
      },
      'dataTable.currentPage': function () {
        vm.refreshData()
      },
      'dataTable.perPage': function () {
        vm.refreshData()
      },
      'filter.service': function () {
        vm.refreshData()
      },
      'filter.active': function () {
        vm.refreshData()
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/error-message/List.vue